// extracted by mini-css-extract-plugin
export default {"header":"firms-management_header__X7DKo"};